var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H3C1.34315 1 0 2.34315 0 4V15C0 16.6569 1.34315 18 3 18H11C12.6569 18 14 16.6569 14 15V4C14 2.34315 12.6569 1 11 1H8ZM3 3C2.44772 3 2 3.44772 2 4V15C2 15.5523 2.44772 16 3 16H11C11.5523 16 12 15.5523 12 15V4C12 3.44772 11.5523 3 11 3V6H3V3ZM9 4V3H5V4H9ZM8.65686 8L7.94975 8.70711L9.36397 10.1213L10.0711 9.41421L8.65686 8ZM8.65686 10.8284L7.94975 10.1213L7.24265 9.41421L3.70711 12.9497V14.364H5.12133L8.65686 10.8284Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignments);
export default __webpack_public_path__ + "static/media/assignments.936ab4ee.svg";
export { ForwardRef as ReactComponent };